<template>
  <div class="mx-5 mt-5">
    <!-- Overlay -->
    <v-overlay absolute :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-card>
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">
          Label Association List - {{ cliente }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="dialog_edit = true" small v-bind="attrs" v-on="on">
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Add label</span>
        </v-tooltip>
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="show_filtri == false"
              @click="clickShowFilters"
              class="mr-4"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="purple lighter-2"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>Show filters</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="show_filtri === true"
              @click="resetFiltro"
              small
              v-bind="attrs"
              v-on="on"
              ><v-icon color="purple lighter-2">mdi-filter-off</v-icon></v-btn
            >
          </template>
          <span>Hide filters</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small @click="goBack" v-bind="attrs" v-on="on">
              <v-icon color="error"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Back</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text id="mainCardText" class="mt-3">
        <v-row align="center" justify="center" v-show="show_filtri">
          <v-col>
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="lista_etichette.filter((i) => i.cod_articolo != null)"
              :item-text="(item) => item.cod_articolo"
              :item-value="(item) => item.cod_articolo"
              label="Item Code"
              style="display: inline-block; max-width: 350px"
              v-model="cod_articolo_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_articolo_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_articolo_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="
                lista_etichette.filter((i) => i.cod_articolo_packaging != null)
              "
              :item-text="(item) => item.cod_articolo_packaging"
              :item-value="(item) => item.cod_articolo_packaging"
              label="Packaging Code"
              style="display: inline-block; max-width: 350px"
              v-model="cod_articolo_packaging_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_articolo_packaging_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_articolo_packaging_search == ""
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="lista_etichette.filter((i) => i.cod_articolo != null)"
              :item-text="(item) => item.cod_label"
              :item-value="(item) => item.cod_label"
              label="Label Code"
              style="display: inline-block; max-width: 350px"
              v-model="cod_label_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_label_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_label_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="stato_list"
              :item-text="(item) => item.des"
              :item-value="(item) => item.des"
              label="Status"
              style="display: inline-block; max-width: 350px"
              v-model="status_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    status_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{ status_search == "" ? "mdi-filter" : "mdi-filter-off" }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-data-table :items="lista_tabella" :headers="headers_etichette">
          <!-- Bottone dialog detail -->
          <template v-slot:[`item.dettaglio`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="item.id_versione_articolo_packaging_label == null"
                  @click="clickShowDetail(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Show detail</span>
            </v-tooltip>
          </template>
          <!-- Bottone dialog di modifica -->
          <template v-slot:[`item.edita`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="Number(item.stato) == 1"
                  @click="clickModificaLabel(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-pencil </v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </template>
          <!-- Bottone dialog storico -->
          <template v-slot:[`item.storico`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="item.id_versione_articolo_packaging_label == null"
                  @click="clickShowHistory(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-bookshelf </v-icon>
                </v-btn>
              </template>
              <span>Show history</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.des_stato`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :color="
                    item.des_stato == 'APPROVED'
                      ? 'success'
                      : item.des_stato == 'REFUSED'
                      ? 'error'
                      : item.des_stato == 'IN EDIT'
                      ? 'primary'
                      : item.des_stato == 'TO BE APPROVED'
                      ? 'orange'
                      : item.des_stato == 'NEW LABEL'
                      ? 'cyan'
                      : ''
                  "
                  >{{
                    item.des_stato == "APPROVED"
                      ? "mdi-check-circle"
                      : item.des_stato == "REFUSED"
                      ? "mdi-close-circle"
                      : item.des_stato == "IN EDIT"
                      ? "mdi-pencil-circle"
                      : item.des_stato == "TO BE APPROVED"
                      ? "mdi-play-speed"
                      : item.des_stato == "NEW LABEL"
                      ? "mdi-new-box"
                      : ""
                  }}</v-icon
                >
              </template>
              <span>
                {{
                  item.des_stato == "APPROVED"
                    ? "APPROVED"
                    : item.des_stato == "REFUSED"
                    ? "REFUSED"
                    : item.des_stato == "IN EDIT"
                    ? "IN EDIT"
                    : item.des_stato == "TO BE APPROVED"
                    ? "TO BE APPROVED"
                    : item.des_stato == "NEW LABEL"
                    ? "NEW LABEL"
                    : ""
                }}
              </span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.conferma`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickConfirm(item)"
                  :disabled="item.stato != 0"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </template>
              <span>Confirm</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>

      <v-dialog persistent v-model="dialog_edit" width="80%">
        <v-card>
          <v-toolbar dense color="indigo" class="white--text">
            <v-toolbar-title>{{
              label.id_label == -1
                ? "Create Label"
                : "Edit Label - " + label.cod_label
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="
                    (e1 == 2 && label.id_label != -1) ||
                    (e1 == 1 && label.id_label == -1)
                  "
                  class="mr-2"
                  @click="previousStep(e1)"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="primary"> mdi-arrow-left </v-icon>
                </v-btn>
              </template>
              <span>Indietro</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="e1 == 3"
                  @click="clickSaveEdit"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>

                <v-btn
                  v-else
                  :disabled="
                    (e1 == 1 && cod_articolo_search_add == '') ||
                    (e1 == 1 && cod_articolo_packaging_search_add == '')
                  "
                  @click="nextStep(e1)"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="primary"> mdi-arrow-right </v-icon>
                </v-btn>
              </template>
              <span>{{ e1 == 3 ? "Save" : "Continue" }}</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickChiudiDialogAgg"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-toolbar>
          <v-stepper v-model="e1">
            <v-stepper-header>
              <template v-for="n in steps">
                <v-stepper-step
                  color="success"
                  :key="`${n}-step`"
                  :complete="e1 > n"
                  :step="n"
                >
                  Step {{ n }}
                </v-stepper-step>

                <v-divider v-if="n !== steps" :key="n"></v-divider>
              </template>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content
                v-for="_n in steps"
                :key="`${_n}-content`"
                :step="_n"
              >
                <div v-if="_n == 1" class="mb-12 mt-4">
                  <v-row>
                    <v-col>
                      <v-autocomplete
                        background-color="#ffffff"
                        dense
                        hide-details
                        :items="
                          lista_etichette.filter((i) => i.cod_articolo != null)
                        "
                        :item-text="
                          (item) =>
                            item.cod_articolo + ' - ' + item.des_articolo
                        "
                        :item-value="(item) => item.cod_articolo"
                        label="Select item code"
                        v-model="cod_articolo_search_add"
                      ></v-autocomplete>
                    </v-col>
                    <v-col>
                      <v-autocomplete
                        :disabled="cod_articolo_search_add == ''"
                        background-color="#ffffff"
                        dense
                        hide-details
                        :items="
                          lista_etichette.filter(
                            (i) =>
                              i.cod_articolo == cod_articolo_search_add &&
                              i.cod_articolo_packaging != null
                          )
                        "
                        :item-text="(item) => item.cod_articolo_packaging"
                        :item-value="(item) => item.cod_articolo_packaging"
                        label="Select packaging code"
                        style="display: inline-block; max-width: 350px"
                        v-model="cod_articolo_packaging_search_add"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </div>
                <v-card v-if="_n == 2" class="mb-12 mt-4" elevation="0">
                  <v-data-table
                    :headers="headers_traduzione"
                    :items="items_traduzione"
                  >
                    <template v-slot:[`header.text`]="{ header }">
                      <h1>{{ header.text }}</h1>
                    </template>
                    <template v-slot:[`header.traduzione`]="{ header }">
                      <h1>{{ header.text }}</h1>
                    </template>
                    <template v-slot:[`item.traduzione`]="{ item }">
                      <v-textarea
                        class="mt-4"
                        style="min-width: 500px"
                        v-model="item.traduzione"
                        outlined
                        filled
                        :background-color="
                          item.traduzione == null || item.traduzione == ''
                            ? 'yellow'
                            : 'white'
                        "
                        rows="3"
                        label="Translate"
                      />
                    </template>
                  </v-data-table>
                </v-card>
                <div v-if="_n == 3 && label.modello != undefined && e1 == 3">
                  <QuickLabelDetail
                    ref="label_detail"
                    :etichetta="label.modello"
                    :show_off="true"
                    :show_tab_off="true"
                    :key="key_reportpage"
                  />
                </div>

                <!-- <v-btn
                  @click="clickSaveEdit"
                  color="success"
                  class="mb-4"
                  v-if="_n == 3"
                >
                  Save
                </v-btn>
                <v-btn v-else color="primary" @click="nextStep(_n)">
                  Continue
                </v-btn> -->
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQV" />
    </v-card>

    <!-- Dialog History -->
    <v-dialog persistent v-model="dialog_show_history" width="50%">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>{{ label.cod_label }} History</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickChiudiDialogHistory"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <v-data-table :items="lista_storico" :headers="headers_history">
          <!-- Bottone dialog di dettaglio -->
          <template v-slot:[`item.dettaglio`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickShowDetail(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Show detail</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- Dialog Dettaglio -->
    <v-dialog :key="key_reportpage" persistent v-model="dialog_show_detail">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>{{ label.cod_label }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickChiudiDialogDetail"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <div class="pa-6">
          <QuickLabelDetail
            ref="label_detail"
            :etichetta="label.modello"
            :show_off="true"
            :show_tab_off="true"
            :key="key_reportpage"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog Conferma -->
    <v-dialog width="30%" persistent v-model="dialog_confirm">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title
            >Confirm Edit - {{ label.cod_label }}</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text>
          <v-row class="ma-2">
            <v-col>
              You will no longer be able to edit the label after committing the
              changes. Are you sure you want to proceed?
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="mt-2">
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickChiudiDialogConfirm"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="error">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Close</span>
              </v-tooltip>
            </v-col>
            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="clickConferma" v-bind="attrs" v-on="on" small>
                    <v-icon color="success">mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Save</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Seleziona Salvataggio -->
    <v-dialog width="40%" persistent v-model="dialog_sel_salvataggio">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title
            >Confirm Edit - {{ label.cod_label }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_sel_salvataggio = false"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-row class="ma-2">
            <v-col>
              <h4>
                You will no longer be able to edit the label after committing
                the changes. Are you sure you want to proceed?
              </h4>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col>
              <v-btn color="orange" @click="saveLabel" small dark>
                NO, SAVE AS DRAFT
              </v-btn>
            </v-col>
            <v-col>
              <v-btn @click="clickSaveAndSubmit" small color="success">
                YES, SAVE AND SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import { FrxToJson, JsonToFrx } from "./FrxJsonConverter";
import QuickLabelDetail from "@/views/LABEL/QuickLabelDetail";

class Label {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "id_label", default_val: -1 },
      { nome: "id_articolo_packaging_label", default_val: null },
      { nome: "new_master", default_val: false },
      { nome: "cod_label", default_val: "" },
      { nome: "modello", default_val: null },
      { nome: "base64", default_val: "" },
      { nome: "campi", default_val: [] },
      { nome: "root", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

export default {
  name: "",
  components: {
    SnackbarQV,
    QuickLabelDetail,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      cliente: "",
      cod_articolo_search: "",
      cod_articolo_packaging_search: "",
      cod_articolo_search_add: "",
      cod_articolo_packaging_search_add: "",
      cod_label_search: "",
      status_search: "NEW LABEL",
      e1: 1,
      label: new Label(),
      obj_label: null,
      steps: 3,
      key_reportpage: 0,

      // Modal
      dialog_add_tar: false,
      dialog_edit: false,
      dialog_confirm: false,
      dialog_sel_salvataggio: false,
      dialog_show_detail: false,
      dialog_show_history: false,
      overlay: false,
      show_filtri: true,

      // Array
      items_parametri: [],
      stato_list: [
        {
          des: "TO BE APPROVED",
          value: 1,
        },
        {
          des: "APPROVED",
          value: 2,
        },
        {
          des: "REFUSED",
          value: 3,
        },
        {
          des: "IN EDIT",
          value: 0,
        },
        {
          des: "NEW LABEL",
          value: null,
        },
      ],
      items_traduzione: [],
      headers_etichette: [
        {
          text: "Detail",
          value: "dettaglio",
          sortable: false,
          align: "center",
        },
        {
          text: "Edit",
          value: "edita",
          sortable: false,
          align: "center",
        },
        {
          text: "History",
          value: "storico",
          sortable: false,
          align: "center",
        },
        {
          text: "Label Code",
          value: "cod_label",
        },
        {
          text: "Packaging Code",
          value: "cod_articolo_packaging",
        },
        {
          text: "Item Code",
          value: "cod_articolo",
        },
        {
          text: "Version",
          value: "num_versione_articolo_packaging_label",
        },
        {
          text: "Status",
          value: "des_stato",
        },
        {
          text: "Confirm",
          value: "conferma",
          sortable: false,
          align: "center",
        },
      ],
      headers_traduzione: [
        {
          text: "Original",
          value: "text",
          sortable: false,
        },
        {
          text: "Translation",
          value: "traduzione",
          sortable: false,
        },
      ],
      headers_history: [
        {
          text: "Detail",
          value: "dettaglio",
          sortable: false,
          align: "center",
        },
        {
          text: "Label Code",
          value: "cod_label",
          sortable: false,
        },
        {
          text: "Version",
          value: "versione",
          sortable: false,
        },
        {
          text: "Creation Date",
          value: "data_creazione",
          sortable: false,
        },
        {
          text: "Status",
          value: "des_stato",
          sortable: false,
        },
      ],

      lista_etichette: [],
      lista_report_tar: [],
      lista_tabella: [],
      lista_storico: [],
    };
  },
  computed: {},
  methods: {
    clickConferma() {
      this.overlay = true;
      const request = {
        controller: "Label",
        method: "PUT",
        richiesta: {
          action: "updatelabelstatus",
          token: localStorage.user_token,
          status: 1,
          id_articolo_packaging_label: this.label.id_articolo_packaging_label,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          console.log(res);
          this.getLabel();
          this.label = new Label();
          this.dialog_confirm = false;
          this.dialog_sel_salvataggio = false;
          this.overlay = false;
          this.$refs.SnackbarQV.print("success", "Successfully saved.");
        })
        .catch((err) => {
          this.overlay = false;
          this.dialog_confirm = false;
          this.dialog_sel_salvataggio = false;
          this.dialog_edit = false;
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    clickChiudiDialogAgg() {
      this.e1 = 1;
      this.cod_articolo_packaging_search_add = "";
      this.cod_articolo_search_add = "";
      this.label = new Label();
      this.items_traduzione = [];
      this.items_parametri = [];
      this.dialog_edit = false;
    },
    clickChiudiDialogConfirm() {
      this.label = new Label();
      this.dialog_confirm = false;
    },
    clickChiudiDialogDetail() {
      this.label = new Label();
      this.dialog_show_detail = false;
    },
    clickChiudiDialogHistory() {
      this.label = new Label();
      this.dialog_show_history = false;
    },
    clickConfirm(item) {
      this.label = new Label(item);
      this.dialog_confirm = true;
    },
    clickDialogAggTar() {
      this.dialog_add_tar = true;
      this.$nextTick(() => {
        this.key_reportpage = this.key_reportpage == 0 ? 1 : 0;
      });
    },
    async clickModificaLabel(item) {
      console.log("Entro in clickModificaLabel", item);
      this.label = new Label(item);
      let campi_traduzione = [];
      let campi_trad_tmp = [];
      if (item.id_versione_articolo_packaging_label != null) {
        await this.getLabelDetail(item);
        campi_traduzione = this.getTextObject(this.label.modello);
      }

      await this.getMasterDetail(item);


      const arr_text_obj = this.getTextObject(this.label.modello);

      this.label.campi.forEach((c) => {
        arr_text_obj.forEach((t) => {
          if (c.id_campo == t.id && c.editabile == 1) {
            this.items_parametri.forEach((p) => {
              let campi_parametri = Object.keys(p);
              for (let i = 0; i < campi_parametri.length; i++) {
                if (campi_parametri[i].toLowerCase() == t.name.toLowerCase()) {
                  t.text = p[campi_parametri[i]];
                }
              }
            });

            if (item.des_stato == "NEW LABEL") {
              t.traduzione = "";
            }

            if (campi_traduzione.length != 0) {
              campi_traduzione.forEach((e) => {
                if (e.id == t.id) {
                  t.traduzione = e.traduzione;
                  let obj_trad = {
                    id: t.id,
                    traduzione: t.traduzione,
                  }
                  campi_trad_tmp.push(obj_trad);
                } else {
                  t.traduzione = "";
                }
              });
            }

            this.items_traduzione.push(t);
          }
        });
      });

      this.items_traduzione.forEach(t => {
       campi_trad_tmp.forEach(c => {
        if (t.id == c.id) {
          t.traduzione = c.traduzione;
        }
       }) 
      })


      this.e1 = 2;
      this.dialog_edit = true;
    },
    clickSaveEdit() {
      this.dialog_sel_salvataggio = true;
    },
    async clickSaveAndSubmit() {
      const label_tmp = new Label(this.label);
      await this.saveLabel();
      this.label = new Label(label_tmp);
      this.clickConferma();
    },
    saveLabel() {
      return new Promise((resolve, reject) => {
        this.overlay = true;
        let label_tmp = JsonToFrx(this.label.modello, this.label.base64);

        const request = {
          controller: "Label",
          method: "PUT",
          richiesta: {
            action: "editpartnerlabel",
            token: localStorage.user_token,
            modello: label_tmp,
            id_articolo_packaging_label: this.label.id_articolo_packaging_label,
          },
        };

        this.$store
          .dispatch("api", request)
          .then((res) => {
            console.log(res);
            this.getLabel();
            this.status_search = "IN EDIT";
            this.filtra();
            this.label = new Label();
            this.e1 = 1;
            this.dialog_edit = false;
            this.dialog_sel_salvataggio = false;
            this.overlay = false;
            this.$refs.SnackbarQV.print("success", "Successfully saved.");
            resolve();
          })
          .catch((err) => {
            this.overlay = false;
            this.dialog_edit = false;
            this.dialog_sel_salvataggio = false;
            this.$refs.SnackbarQV.print("error", err.response.data);
            reject(err);
          });
      });
    },
    clickSaveLabel() {
      this.overlay = true;

      let label_tmp = JsonToFrx(this.label.modello, this.label.base64);

      let arr = [];

      this.label.campi.forEach((e) => {
        let item = {
          id_campo: e.id,
          editabile: e.editabile == true ? 1 : 0,
        };
        arr.push(item);
      });

      const request = {
        controller: "Label",
        method: "PUT",
        richiesta: {
          action: "setmasterdetail",
          token: localStorage.user_token,
          new_master: this.label.new_master,
          cod_label: this.label.cod_label,
          modello: label_tmp,
          id_label: this.label.id_label,
          campi: arr,
        },
      };

      // console.log(JSON.stringify(request));

      this.$store
        .dispatch("api", request)
        .then((res) => {
          console.log(res);
          this.getLabel();
          this.label = new Label();
          this.e1 = 1;
          this.dialog_add_tar = false;
          this.overlay = false;
          this.$refs.SnackbarQV.print("success", "Successfully saved.");
        })
        .catch((err) => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    async clickShowDetail(item) {
      this.label = new Label(item);
      await this.getLabelDetail(item);

      this.$nextTick(() => {
        this.key_reportpage = this.key_reportpage == 0 ? 1 : 0;
      });

      this.dialog_show_detail = true;
    },
    clickShowFilters() {
      this.show_filtri = true;
    },
    clickShowHistory(item) {
      this.label = new Label(item);
      this.getHistory(item);
      this.dialog_show_history = true;
    },
    getHistory(item) {
      const request = {
        controller: "Label",
        method: "POST",
        richiesta: {
          action: "getlabelhistory",
          token: localStorage.user_token,
          id_articolo_packaging_label: item.id_articolo_packaging_label,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_storico = res.data;
            this.lista_storico.forEach((e) => {
              e.data_creazione = e.data_creazione.replace("T", " ");
            });
            this.lista_storico.forEach((e) => {
              this.stato_list.forEach((s) => {
                if (e.stato == s.value) {
                  e.des_stato = s.des;
                }
              });
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getItemsTextObj(arg) {
      this.label.campi = arg;
    },
    getLabel() {
      const request = {
        controller: "Label",
        method: "POST",
        richiesta: {
          action: "getlabelcliente",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_traduzione = [];
            this.lista_etichette = res.data;
            this.lista_etichette.forEach((e) => {
              this.stato_list.forEach((s) => {
                if (e.stato == s.value) {
                  e.des_stato = s.des;
                } else if (e.stato == null) {
                  e.des_stato = "NEW LABEL";
                }
              });
            });
            this.lista_tabella = this.lista_etichette;

            this.filtra();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getLabelDetail(item) {
      console.log(item);
      return new Promise((resolve, reject) => {
        const request = {
          controller: "Label",
          method: "POST",
          richiesta: {
            action: "getlabeldetail",
            token: localStorage.user_token,
            id_versione_articolo_packaging_label:
              item.id_versione_articolo_packaging_label,
          },
        };

        this.$store
          .dispatch("api", request)
          .then((res) => {
            if (res.status === 200) {
              console.log("res => ", res);
              // this.items_parametri = res.data[0].parametri;
              this.label.base64 = res.data.label[0].modello;
              this.label.modello = FrxToJson(this.label.base64);
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                `Criticità rilevata, codice stato: ${res.status}.`
              );
            }
            resolve();
          })
          .catch((err) => {
            this.$refs.SnackbarQV.print("error", `${JSON.parse(err).result}.`);
            reject(err);
          });
      });
    },
    getMasterDetail(item) {
      console.log("item", item);
      return new Promise((resolve, reject) => {
        const request = {
          controller: "Label",
          method: "POST",
          richiesta: {
            action: "getmasterdetail",
            token: localStorage.user_token,
            id_label: item.id_label,
            id_articolo_packaging_label: item.id_articolo_packaging_label,
          },
        };

        this.$store
          .dispatch("api", request)
          .then((res) => {
            if (res.status === 200) {
              this.items_parametri =
                this.items_parametri.length != 0
                  ? this.items_parametri
                  : res.data.parametri;
              this.label.campi = res.data.campi;
              this.label.base64 = res.data.report[0].modello;
              this.label.modello = FrxToJson(this.label.base64);
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                `Criticità rilevata, codice stato: ${res.status}.`
              );
            }
            resolve();
          })
          .catch((err) => {
            this.$refs.SnackbarQV.print(
              "error",
              `${JSON.parse(err.response.data.message).result}.`
            );
            reject(err);
          });
      });
    },
    getTextObject(item, result = new Array()) {
      if (item._tipo == "TextObject" && item.Text) {
        if (!item.Text.includes("[")) {
          result.push({
            id: item._id,
            name: item.Name,
            text: item.Text,
            traduzione: item.Text,
            item_tmp: item,
            editabile: 0,
          });
        }
      }

      item._children.forEach((i) => {
        this.getTextObject(i, result);
      });

      return result;
    },
    goBack() {
      this.$router.push("/home");
    },
    filtra() {
      let items_etichette_tmp = [];
      this.lista_etichette.forEach((elem) => {
        items_etichette_tmp.push(elem);
      });

      if (this.cod_articolo_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.cod_articolo == this.cod_articolo_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.cod_articolo_packaging_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (
            elem.cod_articolo_packaging == this.cod_articolo_packaging_search
          ) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.cod_label_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.cod_label == this.cod_label_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.status_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.des_stato == this.status_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      this.lista_tabella = items_etichette_tmp;
    },
    resetFiltro() {
      // Resetto i filtri
      this.cod_articolo_search = "";
      this.cod_label_search = "";
      this.cod_articolo_packaging_search = "";
      this.status_search = "";

      // Nascondo i filtri
      this.show_filtri = false;

      this.lista_tabella = this.lista_etichette;
    },
    nextStep(n) {
      if (n == 1) {
        this.lista_etichette.forEach((i) => {
          if (
            i.cod_articolo == this.cod_articolo_search_add &&
            i.cod_articolo_packaging == this.cod_articolo_packaging_search_add
          ) {
            this.clickModificaLabel(i);
            return;
          }
        });
      }
      if (n === 2) {
        this.items_traduzione.forEach((t) => {
          t.item_tmp.Text = t.traduzione;
          console.log("log nextStep 2", t);
        });
      }
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },
    previousStep(n) {
      this.e1 = n - 1;
    },
    uploadReportModel() {
      this.label.new_master = true;
      this.label.campi = null;
      this.key_reportpage = this.key_reportpage == 1 ? 0 : 1;
      const that = this;
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", ".frx");
      input.onchange = function () {
        const reader = new FileReader();
        reader.onload = function () {
          that.label.base64 = btoa(encodeURIComponent(reader.result));
          that.label.modello = FrxToJson(that.label.base64);
        };
        reader.readAsText(input.files[0]);
      };
      input.click();
    },
  },
  created() {},
  mounted() {
    this.cliente = localStorage.nominativo;

    this.getLabel();
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
  },
};
</script>
<style scoped>
</style>